module.exports = __webpack_public_path__ + "LocationIcon___3n9xh.svg";